/****** IMAGE ZOOM ******/
document.addEventListener("DOMContentLoaded", function() {
    const container = document.querySelector('.image-container');
    const zoomLens = document.querySelector('.zoom-lens');
    const zoomResult = document.querySelector('.zoom-result');

    // Function to get the cursor position relative to the image container
    function getCursorPos(e) {
        const rect = container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        return { x: x, y: y };
    }

    // Move the lens and the zoom effect
    function moveLens(e) {
        const pos = getCursorPos(e);
        let lensX = pos.x - (zoomLens.offsetWidth / 2);
        let lensY = pos.y - (zoomLens.offsetHeight / 2);

        // Prevent the lens from moving out of bounds
        if (lensX < 0) lensX = 0;
        if (lensY < 0) lensY = 0;
        if (lensX > container.offsetWidth - zoomLens.offsetWidth) {
            lensX = container.offsetWidth - zoomLens.offsetWidth;
        }
        if (lensY > container.offsetHeight - zoomLens.offsetHeight) {
            lensY = container.offsetHeight - zoomLens.offsetHeight;
        }

        // Move the lens
        zoomLens.style.left = lensX + 'px';
        zoomLens.style.top = lensY + 'px';

        // Calculate the zoom factor (cx, cy)
        const cx = zoomResult.offsetWidth / zoomLens.offsetWidth;
        const cy = zoomResult.offsetHeight / zoomLens.offsetHeight;

        // Move the background of zoomResult to match the lens
        zoomResult.style.backgroundPosition = `-${lensX * cx}px -${lensY * cy}px`;
    }

    // Initialize the zoom effect on hover
    // container.addEventListener('mouseenter', function() {
    //     zoomLens.style.display = 'block';
    //     zoomResult.style.display = 'block';

    //     const image = this.querySelector('.product-featured-media');

    //     // Set the background image and size for the zoom result
    //     zoomResult.style.backgroundImage = `url(${image.src})`;
    //     const cx = zoomResult.offsetWidth / zoomLens.offsetWidth;
    //     const cy = zoomResult.offsetHeight / zoomLens.offsetHeight;
    //     zoomResult.style.backgroundSize = `${image.width * cx}px ${image.height * cy}px`;
    // });

    container.addEventListener('mouseenter', function() {
        zoomLens.style.display = 'block';
        zoomResult.style.display = 'block';

        const image = this.querySelector('.product-featured-media');

        // ── DEBUG ──
        console.log('image.width (rendered):', image.width);
        console.log('image.height (rendered):', image.height);
        console.log('image.naturalWidth:', image.naturalWidth);
        console.log('image.naturalHeight:', image.naturalHeight);
        console.log('zoomResult size:', zoomResult.offsetWidth, zoomResult.offsetHeight);
        console.log('zoomLens size:', zoomLens.offsetWidth, zoomLens.offsetHeight);
        console.log('cx:', zoomResult.offsetWidth / zoomLens.offsetWidth);
        console.log('cy:', zoomResult.offsetHeight / zoomLens.offsetHeight);
        // ── END DEBUG ──

        zoomResult.style.backgroundImage = `url(${image.src})`;
        const cx = zoomResult.offsetWidth / zoomLens.offsetWidth;
        const cy = zoomResult.offsetHeight / zoomLens.offsetHeight;
        zoomResult.style.backgroundSize = `${image.width * cx}px ${image.height * cy}px`;
    });

    container.addEventListener('mouseleave', function() {
        zoomLens.style.display = 'none';
        zoomResult.style.display = 'none';
    });

    container.addEventListener('mousemove', moveLens);
});